<template>
  <div class="scroll-vertical">
    <detail-item
      name="Event Type"
      imgName="circle">
      File {{ getEnumString('type', event.type) }}
    </detail-item>
    <detail-item
      name="Event Timestamp"
      imgName="circle">
      {{ event.timestamp | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Path"
      imgName="circle">
      {{ event.path }}
    </detail-item>
    <detail-item
      name="Process"
      imgName="circle">
      {{ relatedProcess(event.pid) }}
    </detail-item>
    <detail-item
      name="User"
      imgName="circle">
      {{ relatedUser(event.uid) }}
    </detail-item>
    <detail-item
      name="Group"
      imgName="circle">
      {{ relatedGroup(event.gid) }}
    </detail-item>
  </div>
</template>

<script>
import gmt from '@/mixins/gmt';
import events from '@/mixins/events';
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'GPFSEvent',
  mixins: [events, gmt],
  components: { DetailItem },
  props: {
    event: {
      type: Object,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      def: this.$typeDefs.events.GPFSEvent,
    };
  },
};
</script>
